const PERCENTAGE_BASE = 100;

/**
 * Totals of an ordered line, computed from a quantity, the unit price including taxes and the VAT
 * rate frozen on the line. The total excluding taxes is derived from the total including taxes —
 * the only price an external order carries — the VAT rate being expressed in percentage points
 * (10 for 10 %, COR-1679).
 *
 * @param {Object} params
 * @param {number} params.quantity - The quantity weighing the line
 * @param {number} params.priceWithTaxes - The unit price including taxes of the line
 * @param {number} [params.vatRate] - The VAT rate of the line, in percentage points
 *
 * @returns {{ totalWithTaxes: number, totalWithoutTaxes: number }} The totals of the line
 */
export const buildOrderLineTotals = ({ quantity, priceWithTaxes, vatRate }) => {
  const totalWithTaxes = quantity * priceWithTaxes;

  return {
    totalWithTaxes,
    totalWithoutTaxes: totalWithTaxes / (1 + (vatRate ?? 0) / PERCENTAGE_BASE),
  };
};
